export { default as LogoC } from "./logo-c.svg";
export { default as LogoCaf } from "./logo-caf.svg";
export { default as LogoCafSub } from "./logo-caf-sub.svg";
export { default as LogoCafnCo } from "./logo-cafnco.svg";
